module.exports = __webpack_public_path__ + "fonts/NunitoSans-ExtraBold.a8e1996.ttf";